import React from "react";
import { Link } from "react-router-dom";
import PostConnectButton from "../feed_page/PostConnectButton";
import { Badge } from "../ui/badge";
import { defaultPfpUrl } from "../utils";

/**
 * Compact org member row: name, role, contact, Connect (post variant).
 * @param {Object} props
 * @param {object} props.affiliation
 * @param {number} props.userId
 * @param {object} [props.user]
 * @returns {JSX.Element}
 */
function OrgMemberRow({ affiliation, userId, user }) {
  const member = affiliation?.user || {};
  const displayName =
    member.first_name || member.last_name
      ? `${member.first_name || ""} ${member.last_name || ""}`.trim()
      : member.username || "Member";

  const connectItem = {
    author_id: member.id,
    author_is_org: false,
    user_connection_status: member.user_connection_status || "none",
    connection_id: member.connection_id || 0,
  };

  return (
    <div className="flex items-start gap-3 rounded-lg px-2 py-2.5 transition-colors hover:bg-ui-muted">
      <Link to={`/profile/${member.id}`} className="shrink-0">
        <img
          src={member.pfp_url || defaultPfpUrl}
          alt=""
          className="h-10 w-10 rounded-full object-cover ring-1 ring-ui-border"
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = defaultPfpUrl;
          }}
        />
      </Link>
      <div className="min-w-0 flex-1">
        <div className="flex min-w-0 flex-wrap items-center gap-2">
          <Link
            to={`/profile/${member.id}`}
            className="truncate text-sm font-semibold text-accent hover:text-text-accent-hover"
          >
            {displayName}
          </Link>
          {affiliation.role ? (
            <Badge variant="outline" className="font-normal text-accent">
              {affiliation.role}
            </Badge>
          ) : null}
        </div>
        <div className="mt-1 space-y-0.5 text-xs text-text-muted">
          {member.email ? <div className="truncate">{member.email}</div> : null}
          {member.phone ? <div className="truncate">{member.phone}</div> : null}
        </div>
      </div>
      <div className="shrink-0 self-center">
        <PostConnectButton userId={userId} user={user} item={connectItem} />
      </div>
    </div>
  );
}

export default OrgMemberRow;
